// document.querySelectorAll('.c-accordion__header').forEach(header => {
//     header.addEventListener('click', () => {
//         const content = header.nextElementSibling;
//         content.classList.toggle('is-open');
//     });
// });

class Accordion {
    constructor(selector = '.acc-trigger') {
        this.triggers = document.querySelectorAll(selector);

        if (!this.triggers.length) return;

        this.bindEvents();
    }

    bindEvents() {
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => this.toggle(e.currentTarget));
        });
    }

    toggle(trigger) {
        const item = this.getItem(trigger);
        const isActive = item.classList.contains('active');

        if (isActive) {
            this.close(trigger, item);
        } else {
            this.open(trigger, item);
        }
    }

    open(trigger, item) {
        item.classList.add('active');
        trigger.setAttribute('aria-expanded', 'true');
    }

    close(trigger, item) {
        item.classList.remove('active');
        trigger.setAttribute('aria-expanded', 'false');
    }

    getItem(trigger) {
        // évite parentNode fragile, on remonte proprement
        return trigger.closest('.acc-item') || trigger.parentElement.parentElement;
    }

    // 🧠 API publique pour déclenchement par code
    openByIndex(index) {
        const trigger = this.triggers[index];
        if (!trigger) return;

        const item = this.getItem(trigger);
        this.open(trigger, item);
    }

    closeByIndex(index) {
        const trigger = this.triggers[index];
        if (!trigger) return;

        const item = this.getItem(trigger);
        this.close(trigger, item);
    }

    toggleByIndex(index) {
        const trigger = this.triggers[index];
        if (!trigger) return;

        this.toggle(trigger);
    }

    // optionnel : ouvrir par élément DOM
    openByElement(trigger) {
        const item = this.getItem(trigger);
        this.open(trigger, item);
    }
}

// init
document.addEventListener('DOMContentLoaded', () => {
    window.accordion = new Accordion('.acc-trigger');
});
